import * as React from "react"

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

const createSvgIcon = (paths: React.ReactNode, displayName: string) => {
  const Component = React.memo(
    React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
      const { viewBox = "0 0 24 24", color, title, ...other } = props

      if (color) {
        props.style = props.style || {}
        props.style["color"] = color
      }

      return (
        <svg
          focusable="false"
          viewBox={viewBox}
          ref={ref}
          style={{ display: "inline-block", ...props.style }}
          {...other}
        >
          {paths}
          {title && <title>{title}</title>}
        </svg>
      )
    })
  )

  Component.displayName = `${displayName}Icon`

  return Component
}

export default createSvgIcon
